import { Component, OnInit } from '@angular/core';
import { HeaderService } from '../header/header.service';

@Component({
  selector: 'app-menu-hamburger',
  templateUrl: './menu-hamburger.component.html',
  styleUrls: ['./menu-hamburger.component.scss'],
})
export class MenuHamburgerComponent implements OnInit {
  isActive!: boolean;

  constructor(private headerService: HeaderService) {}

  ngOnInit(): void {
    this.headerService.getIsMenuOpen().subscribe((resp) => {
      this.isActive = resp;
    });
  }

  toggleMenuHamburger() {
    this.headerService.toggleMenu();
  }
}
